import { useState } from "react";
import {
  useOmniCreateSnapshotMutation,
  useOmniListSnapshotHistoryQuery,
  Metric,
} from "../../../lib/apollo/graphql/omni/omni-generated";

export const useSnapshot = (distributionId: string | null) => {
  const [isCreating, setIsCreating] = useState(false);
  const [latestSnapshotWithCreatedBy, setLatestSnapshotWithCreatedBy] = useState<any>(null);

  // Query to fetch snapshot history
  const {
    data: historyData,
    loading: historyLoading,
    refetch: refetchHistory,
  } = useOmniListSnapshotHistoryQuery({
    variables: {
      input: {
        distributionId: distributionId || "",
        page: 1,
        pageSize: 1, // Get only the latest one for display
      },
    },
    skip: !distributionId,
    fetchPolicy: "network-only",
  });

  // Mutation to create snapshot
  const [createSnapshotMutation] = useOmniCreateSnapshotMutation();

  const createSnapshot = async (
    value: number,
    note: string,
    createdBy: string
  ) => {
    if (!distributionId) {
      throw new Error("Distribution ID is required");
    }

    try {
      setIsCreating(true);

      const result = await createSnapshotMutation({
        variables: {
          input: {
            distributionId,
            metric: Metric.View,
            value,
            capturedAt: new Date().toISOString(),
            source: "manual",
            note,
            createdBy,
          },
        },
      });

      // Refetch history to update the list
      await refetchHistory();

      // Store the created snapshot with createdBy info
      if (result.data?.createSnapshot) {
        setLatestSnapshotWithCreatedBy(result.data.createSnapshot);
      }

      return result.data?.createSnapshot;
    } catch (error) {
      console.error("Error creating snapshot:", error);
      throw error;
    } finally {
      setIsCreating(false);
    }
  };

  const historySnapshot = historyData?.listSnapshotHistory?.items?.[0];

  // Use the snapshot with createdBy if available, otherwise use history snapshot
  const latestSnapshot = latestSnapshotWithCreatedBy || historySnapshot || null;

  return {
    latestSnapshot,
    historyLoading,
    isCreating,
    createSnapshot,
    refetchHistory,
  };
};
